var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"update-password-page"}},[_c('h2',{staticClass:"intro-y text-lg font-medium mt-10"},[_vm._v(" 更改密碼 ")]),_c('password-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }